import '../../libs/jquery.formstyler';
import _ from 'lodash';

$('.select-with-search.selectGoodBrand').styler({
    selectSmartPositioning: false,
    selectSearch: true,
    selectSearchLimit: 2,
    customSearch: true,
    locale: LOCALE_STYLER,
    onSearch: function (query, li) {
        var notFound = $('.jq-selectbox.selectGoodBrand .jq-selectbox__not-found').hide();

        li.each(function () {
            var matches = $(this).data('name');

            if (typeof matches === 'undefined') {
                $(this).hide();
                return;
            }

            $(this).toggle(!!matches.match(new RegExp('.*?' + query + '.*?', 'i')));
        });

        notFound.toggle(!!li.filter(':visible').length < 1);
    },
});

var iOS =
    navigator.userAgent.match(/(iPad|iPhone|iPod)/i) && !navigator.userAgent.match(/(Windows\sPhone)/i)
        ? true
        : false;

$('.select-with-search.findGoodModels').styler({
    selectSmartPositioning: false,
    selectSearch: true,
    selectSearchLimit: 0,
    customSearch: true,
    locale: LOCALE_STYLER,
    onSearch: function (query, li) {
        var goodId = $('.js-page-good').data('id'),
            brandId = $('select.selectGoodBrand:visible').val();

        if (!query.length) {
            $('.jq-selectbox.findGoodModels select option').not('.search_query').not('.select_placeholder').remove();
            $('.jq-selectbox.findGoodModels ul li').not('.search_query').not('.select_placeholder').remove();

            return;
        }

        $(this).find('li.search_query').show().text(query);
        $(this).find('option.search_query').val(query).text(query);

        $.get(`/brands/${brandId}/models/`, {query: query}, function (response) {
            if (!response || !response.data) {
                return;
            }

            $('.jq-selectbox.findGoodModels select option').not('.search_query').not('.select_placeholder').remove();
            $('.jq-selectbox.findGoodModels ul li').not('.search_query').not('.select_placeholder').remove();

            response.data.forEach(function (model) {
                $('select.findGoodModels').trigger('addOption', model);
            });
        });
    },
});

$('select.selectGoodBrand').on('change', function () {
    $('.findGoodModels').prop('disabled', false).trigger('refresh');

    /*if (iOS) {
        var brandId = $('select.selectGoodBrand').val();

        $.get(`/brands/${brandId}/models/`, {query: ''}, function (response) {
            if (!response || !response.data) {
                return;
            }

            response.data.forEach(function (model) {
                $('select.findGoodModels').append(`<option value="${model}">${model}</option>`);
            });
        });
    }*/
});

$('.compatibility_btn').on('click', function () {
    var goods_id = $('.js-page-good').data('id'),
        model_name = $('.jq-selectbox.findGoodModels .jq-selectbox__select-text').text(),
        brand_id = $('select.selectGoodBrand:visible').val();

    $.ajax({
        type: 'post',
        url: '/good/check-compatibility-with-model/',
        data: {goods_id: goods_id, model_name: model_name, brand_id: brand_id},
        success: function (response) {
            $('.compatibility_result').hide();

            if (response.result) {
                $('.compatibility_result.positive')
                    .show()
                    .find('.compatibility_link')
                    .attr('href', response.url)
                    .text(response.urlTitle);
                $('.compatibility_result.positive .js-answer').text(response.answer);
            } else {
                $('.compatibility_result.negative').show();

                if (response.alternatives && _.size(response.alternatives) > 0) {
                    $('.compatibility_result.negative .js-answer').html(`<br>${response.answer}`);

                    $('.compatibility_result.negative .js-alternatives-show').html(response.not_suitable_answer).show();
                    $('.compatibility_result.negative .js-alternatives-hide').hide();

                    const alternativesHtml = _.map(response.alternatives, (title, url) => {
                        return `<li style="margin-bottom:5px"><a href="${url}" target="_blank">${title}</a></li>`;
                    });
                    $('.compatibility_result.negative .js-alternatives').html(
                        '<ul style="list-style-type:disc">' + alternativesHtml.join('') + '</ul>'
                    );
                } else {
                    $('.compatibility_result.negative .js-alternatives-show').hide();
                    $('.compatibility_result.negative .js-alternatives-hide').show();
                }
            }
        },
    });
});
